const state = {
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    authorities: null,
    email: null,
    isRequesting: false,
}

export default state